// import React, { useState } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';

// const SINGLE_PLAN = {
//   id: 'ventara_pro',
//   name: 'Ventara Cloud All-In-One',
//   badge: 'Complete Suite',
//   price: 3000,
//   currency: 'PKR',
//   billingPeriod: 'month',
//   description: 'Full-featured diagnostic & EMR software suite tailored for modern laboratories.',
//   features: [
//     'Unlimited Patient Registrations & Lab Tests',
//     'Custom Branded PDF Reports with Doctor Signatures',
//     'Real-time Billing, Receipts & Dues Tracking',
//     'Multi-User Access Control (Admins & Technicians)',
//     'Financial Revenue & Daily Summary Analytics',
//     'Automated WhatsApp/Email Integration Ready'
//   ]
// };

// const WHATSAPP_NUMBER = '923089394272'; // International format without leading '+' or spaces

// const SubscriptionPlans = ({ labName = '', userEmail = '' }) => {
//   const [labDetail, setLabDetail] = useState(labName);
//   const [contactEmail, setContactEmail] = useState(userEmail);

//   const handleWhatsAppRedirect = (e) => {
//     e.preventDefault();

//     // Construct a pre-formatted message for WhatsApp
//     const message = 
//       `*Ventara Cloud Subscription Request*\n\n` +
//       `*Plan:* ${SINGLE_PLAN.name}\n` +
//       `*Price:* ${SINGLE_PLAN.currency} ${SINGLE_PLAN.price.toLocaleString()}/${SINGLE_PLAN.billingPeriod}\n` +
//       `*Lab/Facility Name:* ${labDetail || 'Not Provided'}\n` +
//       `*Contact Email:* ${contactEmail || 'Not Provided'}\n\n` +
//       `Hello, I would like to activate my Ventara Cloud subscription plan. Please guide me through the setup and payment process.`;

//     // Encode message for URI
//     const encodedMessage = encodeURIComponent(message);
//     const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`;

//     // Redirect to WhatsApp
//     window.open(whatsappUrl, '_blank');
//   };

//   return (
//     <div className="min-vh-100 py-5 common-background-color common-FontFamily">
//       <div className="container">
        
//         {/* Header */}
//         <div className="text-center mb-4">
//           <span className="badge bg-light text-primary border mb-2 px-3 py-2 common-FontSize-small common-FontWeight">
//             Step 1: Activate Subscription
//           </span>
//           <h2 className="fw-bold text-dark mb-2">Ventara Cloud Subscription</h2>
//           <p className="text-secondary common-FontSize-small">
//             Simple, transparent pricing to scale your diagnostic laboratory operations without hidden fees.
//           </p>
//         </div>

//         {/* Pricing Card */}
//         <div className="row justify-content-center">
//           <div className="col-lg-6 col-md-8">
//             <div className="card common-box-shadow common-box-border bg-white p-4 position-relative">
              
//               {/* Badge */}
//               <div className="d-flex justify-content-between align-items-center mb-3">
//                 <span className="badge bg-primary px-3 py-2 common-FontSize-small">
//                   {SINGLE_PLAN.badge}
//                 </span>
//                 <span className="text-muted common-Font-10">Instant WhatsApp Setup</span>
//               </div>

//               {/* Title & Price */}
//               <h3 className="fw-bold text-dark mb-1">{SINGLE_PLAN.name}</h3>
//               <p className="text-muted common-FontSize-small mb-3">{SINGLE_PLAN.description}</p>
              
//               <div className="d-flex align-items-baseline gap-2 my-2 p-3 bg-light rounded border">
//                 <span className="display-6 fw-bold common-color">
//                   {SINGLE_PLAN.currency} {SINGLE_PLAN.price.toLocaleString()}
//                 </span>
//                 <span className="text-muted">/ {SINGLE_PLAN.billingPeriod}</span>
//               </div>

//               <hr className="my-3 opacity-25" />

//               {/* Included Features */}
//               <h6 className="fw-bold common-FontSize-small text-dark mb-2">Included in this plan:</h6>
//               <ul className="list-unstyled d-flex flex-column gap-2 mb-4">
//                 {SINGLE_PLAN.features.map((feature, i) => (
//                   <li key={i} className="common-FontSize-small d-flex align-items-center gap-2 text-dark">
//                     <span className="common-color fw-bold">✓</span> {feature}
//                   </li>
//                 ))}
//               </ul>

//               {/* Facility Details Form prior to WhatsApp Redirection */}
//               <form onSubmit={handleWhatsAppRedirect} className="border-top pt-3">
//                 <div className="mb-2 text-start">
//                   <label className="common-Labels mb-1">Laboratory / Clinic Name</label>
//                   <input
//                     type="text"
//                     className="form-control common-Input p-2"
//                     placeholder="e.g., City Diagnostic Lab"
//                     value={labDetail}
//                     onChange={(e) => setLabDetail(e.target.value)}
//                     required
//                   />
//                 </div>

//                 <div className="mb-3 text-start">
//                   <label className="common-Labels mb-1">Contact Email</label>
//                   <input
//                     type="email"
//                     className="form-control common-Input p-2"
//                     placeholder="name@labdomain.com"
//                     value={contactEmail}
//                     onChange={(e) => setContactEmail(e.target.value)}
//                     required
//                   />
//                 </div>

//                 <button 
//                   type="submit" 
//                   className="Submit_Button w-100 py-3 fw-bold d-flex align-items-center justify-content-center gap-2"
//                   style={{ backgroundColor: '#25D366', borderColor: '#25D366' }}
//                 >
//                   <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
//                     <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.64 1.93 6.56 6.56 0 0 1 1.928 4.64c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.099-.834-.308-1.587-.98-.588-.524-.985-1.172-1.1-1.37-.116-.197-.013-.304.085-.402.088-.088.197-.232.296-.348.1-.116.133-.197.197-.33.065-.133.033-.248-.017-.348-.05-.099-.445-1.072-.61-1.47-.16-.388-.323-.335-.445-.341l-.38-.007c-.131 0-.348.049-.529.248-.182.197-.698.683-.698 1.666 0 .983.715 1.934.816 2.067.101.133 1.408 2.15 3.411 3.016.476.206.848.328 1.138.421.479.153.914.131 1.258.08.384-.058 1.17-.478 1.334-.94.165-.461.165-.856.116-.94-.049-.083-.182-.148-.38-.247z"/>
//                   </svg>
//                   Subscribe via WhatsApp (PKR 4,000/mo)
//                 </button>
//               </form>

//               <p className="text-center text-muted common-Font-10 mt-3 mb-0">
//                 Support Team: +92 308 9394272 | Instant Setup Assistance
//               </p>
//             </div>
//           </div>
//         </div>

//       </div>
//     </div>
//   );
// };

// export default SubscriptionPlans;


import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const SINGLE_PLAN = {
  id: 'ventara_pro',
  name: 'Ventara Cloud All-In-One',
  badge: 'Complete Suite',
  price: 3000,
  currency: 'PKR',
  billingPeriod: 'month',
  description: 'Full-featured diagnostic & EMR software suite tailored for modern laboratories.',
  features: [
    'Unlimited Patient Registrations & Lab Tests',
    'Custom Branded PDF Reports & Signatures',
    'Real-time Billing, Receipts & Dues Tracking',
    'Multi-User Access Control (Admins & Techs)',
    'Financial Revenue & Daily Summary Analytics',
    'Automated WhatsApp/Email Integration Ready'
  ]
};

const WHATSAPP_NUMBER = '923089394272';

const SubscriptionPlans = ({ labName = '', userEmail = '' }) => {
  const [labDetail, setLabDetail] = useState(labName);
  const [contactEmail, setContactEmail] = useState(userEmail);

  const handleWhatsAppRedirect = (e) => {
    e.preventDefault();

    const message = 
      `*Ventara Cloud Subscription Request*\n\n` +
      `*Plan:* ${SINGLE_PLAN.name}\n` +
      `*Price:* ${SINGLE_PLAN.currency} ${SINGLE_PLAN.price.toLocaleString()}/${SINGLE_PLAN.billingPeriod}\n` +
      `*Lab/Facility Name:* ${labDetail || 'Not Provided'}\n` +
      `*Contact Email:* ${contactEmail || 'Not Provided'}\n\n` +
      `Hello, I would like to activate my Ventara Cloud subscription plan. Please guide me through the setup and payment process.`;

    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`;

    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="vh-100 d-flex align-items-center justify-content-center common-background-color common-FontFamily p-3">
      <div className="container" style={{ maxWidth: '960px' }}>
        
        {/* Compact Header */}
        <div className="text-center mb-3">
          <span className="badge bg-light text-primary border px-3 py-1 common-FontSize-small common-FontWeight mb-1">
            Step 1: Activate Subscription
          </span>
          <h3 className="fw-bold text-dark mb-0">Ventara Cloud Subscription</h3>
        </div>

        {/* Horizontal Card Layout */}
        <div className="card common-box-shadow common-box-border bg-white overflow-hidden">
          <div className="row g-0">
            
            {/* Left Column: Plan Details & Features */}
            <div className="col-md-6 p-4 border-end bg-light d-flex flex-column justify-content-between">
              <div>
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span className="badge bg-primary px-2 py-1 common-FontSize-small">
                    {SINGLE_PLAN.badge}
                  </span>
                  <span className="text-muted common-Font-10">Instant Setup</span>
                </div>

                <h4 className="fw-bold text-dark mb-1">{SINGLE_PLAN.name}</h4>
                <p className="text-muted common-FontSize-small mb-3">{SINGLE_PLAN.description}</p>
                
                <div className="d-flex align-items-baseline gap-2 mb-3">
                  <span className="fs-2 fw-bold common-color">
                    {SINGLE_PLAN.currency} {SINGLE_PLAN.price.toLocaleString()}
                  </span>
                  <span className="text-muted common-FontSize-small">/ {SINGLE_PLAN.billingPeriod}</span>
                </div>

                <h6 className="fw-bold common-FontSize-small text-dark mb-2">Included Features:</h6>
                <ul className="list-unstyled d-flex flex-column gap-2 mb-0">
                  {SINGLE_PLAN.features.map((feature, i) => (
                    <li key={i} className="common-FontSize-small d-flex align-items-center gap-2 text-dark">
                      <span className="common-color fw-bold">✓</span> {feature}
                    </li>
                  ))}
                </ul>
              </div>

              <p className="text-muted common-Font-10 mb-0 mt-3 pt-2 border-top">
                Support Line: +92 308 9394272
              </p>
            </div>

            {/* Right Column: Activation Form */}
            <div className="col-md-6 p-4 d-flex flex-column justify-content-center bg-white">
              <h5 className="fw-bold text-dark mb-1">Facility Information</h5>
              <p className="text-muted common-FontSize-small mb-3">Enter your details to generate your activation request.</p>

              <form onSubmit={handleWhatsAppRedirect}>
                <div className="mb-3 text-start">
                  <label className="common-Labels mb-1">Laboratory / Clinic Name</label>
                  <input
                    type="text"
                    className="form-control common-Input p-2"
                    placeholder="e.g., City Diagnostic Lab"
                    value={labDetail}
                    onChange={(e) => setLabDetail(e.target.value)}
                    required
                  />
                </div>

                <div className="mb-4 text-start">
                  <label className="common-Labels mb-1">Contact Email</label>
                  <input
                    type="email"
                    className="form-control common-Input p-2"
                    placeholder="name@labdomain.com"
                    value={contactEmail}
                    onChange={(e) => setContactEmail(e.target.value)}
                    required
                  />
                </div>

                <button 
                  type="submit" 
                  className="Submit_Button w-100 py-2 fw-bold d-flex align-items-center justify-content-center gap-2"
                  style={{ backgroundColor: '#25D366', borderColor: '#25D366' }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.64 1.93 6.56 6.56 0 0 1 1.928 4.64c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.099-.834-.308-1.587-.98-.588-.524-.985-1.172-1.1-1.37-.116-.197-.013-.304.085-.402.088-.088.197-.232.296-.348.1-.116.133-.197.197-.33.065-.133.033-.248-.017-.348-.05-.099-.445-1.072-.61-1.47-.16-.388-.323-.335-.445-.341l-.38-.007c-.131 0-.348.049-.529.248-.182.197-.698.683-.698 1.666 0 .983.715 1.934.816 2.067.101.133 1.408 2.15 3.411 3.016.476.206.848.328 1.138.421.479.153.914.131 1.258.08.384-.058 1.17-.478 1.334-.94.165-.461.165-.856.116-.94-.049-.083-.182-.148-.38-.247z"/>
                  </svg>
                  Subscribe via WhatsApp (PKR 3,000/mo)
                </button>
              </form>
            </div>

          </div>
        </div>

      </div>
    </div>
  );
};

export default SubscriptionPlans;